import loadable from '@loadable/component';

// 懒加载组件
const InDetailQuery = loadable(() => import('./inDetailQuery/InDetailQuery'));
const OutDetailQuery = loadable(() => import('./outDetailQuery/OutDetailQuery'));
const InventoryDetailQuery = loadable(() => import('./inventoryDetailQuery/InventoryDetailQuery'));

export const subRoutes = [
  {
    // M255001 供应商：入库明细查询
    path: '/InDetailQuery',
    component: InDetailQuery
  },
  {
    // M255002 供应商：消耗明细查询
    path: '/OutDetailQuery',
    component: OutDetailQuery
  },
  {
    // M255003 供应商：库存余额明细查询
    path: '/InventoryDetailQuery',
    component: InventoryDetailQuery
  }
];
